/**
 * Loading, empty and failed states (piece 4): every List Page, Record Page
 * and Tile has all three, never one blank area. Still loading, nothing here
 * yet, and this did not load are three different messages, and the empty one
 * names the next action while the failed one offers a retry.
 */
export type AsyncState<T> = { kind: 'loading' } | { kind: 'empty' } | { kind: 'failed'; error: string } | { kind: 'ready'; data: T };

export function deriveAsyncState<T>(loading: boolean, error: string | null, data: readonly T[] | null): AsyncState<readonly T[]> {
  if (loading) return { kind: 'loading' };
  if (error) return { kind: 'failed', error };
  if (!data || data.length === 0) return { kind: 'empty' };
  return { kind: 'ready', data };
}

export const asyncStateKinds = ['loading', 'empty', 'failed', 'ready'] as const;
